export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DEFAULT_VALUES = {
  ptsPersonID: null,
  ptsSupervisorID: null,
  DepartmentName: '',
  Position: '',
  Occupation: '',
  Rank: '',
  Status: '',
  Pay: '',
  Rate: '',
  Shift: '',
  Hired: null,
  Terminated: null,
  TerminationReason: '',
};
